export default {"src":"/uk/_next/static/media/worldwide.28187d38.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};